import { render, staticRenderFns } from "./IconSpinner.vue?vue&type=template&id=ce6d2286"
import script from "./IconSpinner.vue?vue&type=script&lang=js"
export * from "./IconSpinner.vue?vue&type=script&lang=js"
import style0 from "./IconSpinner.vue?vue&type=style&index=0&id=ce6d2286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports